import { GraphQLClient } from 'graphql-request'

export class MoisesGraphQL {
  config: any

  session: any

  graphQLClient: GraphQLClient

  constructor(config: any, session: any) {
    this.config = config
    this.session = session

    const endpoint = `${this.config.apiEndpoint}${
      this.config.apiEndpoint.endsWith('/') ? '' : '/'
    }graphql`

    this.graphQLClient = new GraphQLClient(endpoint)
  }

  async fetch({ variables, query }: any): Promise<any> {
    return this.graphQLClient.request(query, variables, {
      Authorization: this.session.token,
      ...this.config.headers
    })
  }
}
